import React, { useState, useEffect, useCallback } from "react";
import { Route, Switch, Redirect, useHistory } from "react-router-dom";
import { Routes } from "../routes";
import Sidebar from "../components/Sidebar";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import Preloader from "../components/Preloader";
import SystemNotificationBanner from "../components/SystemNotificationBanner";
import { useCookies } from "react-cookie";
import { useItemPerPage } from "../helper/useItemPerPage";

// authen
import Signin from "./authenticate/Signin";
import Signup from "./authenticate/Signup";
import ForgotPassword from "./authenticate/ForgotPassword";
import ResetPassword from "./authenticate/ResetPassword";
import ServerError from "./authenticate/ServerError";

// trang chủ
import Overview from "./dashboard/DashboardOverview";
import NotificationManagement from "./notifications/NotificationManagement";
import CustomerOverview from "./__customer__/dashboard/DashboardOverview";
import SettingOverview from "./__setting__/dashboard/DashboardOverview";
import DeviceManagementOverview from "./__device-management__/dashboard/DashboardOverview";
import DeviceManagementDevices from "./__device-management__/devices/DevicesPage";
import DeviceManagementEmployees from "./__device-management__/employees/EmployeesPage";
import DeviceManagementAdmins from "./__device-management__/admins/AdminsPage";
import DeviceManagementPrintQueue from "./__device-management__/print-queue/PrintQueuePage";
import ClassicOverview from "./__classic__/dashboard/DashboardOverview";

// nạp tiền
import AddChargeApp from "./fund/charge/add-charge/AddCharge";
import AddChargeWeb from "./fund/charge/add-charge-web/AddCharge";
import CashbackHistoryWeb from "./fund/charge/refund-history-web/RefundHistory";
import ChargeHistoryApp from "./fund/charge/charge-history-app/ChargeHistory";
import ChargeHistoryWeb from "./fund/charge/charge-history-web/ChargeHistory";
import IssueCharge from "./fund/charge/issue-charge/IssueCharge";
import RefundApp from "./fund/refund/add-refund/AddRefund";
import RefundWeb from "./fund/refund/add-refund-web/AddRefund";
import RefundHistoryApp from "./fund/refund/refund-history/RefundHistory";
import RefundHistoryWeb from "./fund/refund/refund-history-web/RefundHistory";

// quản lý
import Cart from "./management/cart/Cart";
import Ticket from "./management/ticket/Ticket";
import IssueTicket from "./management/issue-ticket/IssueTicket";
import MBRefund from "./management/mb-refund/MBRefund";
import MBDoisoat from "./management/mb-doisoat/MBDoisoat";
import WithdrawRequestApp from "./management/withdraw-request/app/list/WithdrawRequest";
import WithdrawRequestAppConfirmed from "./management/withdraw-request/app/confirmed/WithdrawRequest";

import WithdrawRequestWeb from "./management/withdraw-request/web/list/WithdrawRequest";
import WithdrawRequestWebConfirmed from "./management/withdraw-request/web/confirmed/WithdrawRequest";

// kết quả
import KenoResult from "./result/keno/Keno";
import PowerResult from "./result/power/Power";
import MegaResult from "./result/mega/Mega";
import Lotto535Result from "./result/lotto535/Lotto535";
import Max3dResult from "./result/max3d/Max3d";
import Max3dProResult from "./result/max3dpro/Max3dPro";
import RewardCalcJob from "./reward-calc-job/RewardCalcJob";
import RewardCalcSetting from "./reward-calc-job/RewardCalcSetting";

// thống kê
import ChargeSummary from "./statistic/charge-summary/ChargeSummary";
import Reward from "./statistic/reward/Reward";
import WIPReward from "./statistic/wip-reward/Reward";
import WithdrawSummaryApp from "./statistic/withdraw-summary-app/WithdrawSummary";
import WithdrawSummaryWeb from "./statistic/withdraw-summary-web/WithdrawSummary";

// kỳ quay
import DayOff from "./period/day-off/DayOff";
import KenoPeriod from "./period/keno/Keno";
import CurrentPeriod from "./period/current-period/CurrentPeriod";
import PowerPeriod from "./period/power/Power";
import MegaPeriod from "./period/mega/Mega";
import Lotto535Period from "./period/lotto535/Lotto535";
import Max3dPeriod from "./period/max3d/Max3d";
import Max3dProPeriod from "./period/max3dpro/Max3dPro";

// thông tin chung
import Devices from "./commons/device/Devices";
import Games from "./commons/game/Games";
import Bank from "./commons/bank/Bank";
import Banner from "./commons/banner/Banner";
import Contact from "./commons/contact/Contact";
import Invite from "./commons/invite/Invite";
import Notification from "./commons/notification/Notification";

// tài khoản
import User from "./account/user/User";
import TransactionHistory from "./account/transaction-history/TransactionHistory";
import CashFlow from "./statistic/cash-flow/CashFlow";
import Employee from "./account/employee/Employee";

import SystemNotification from "./systems/notification/SystemNotification";
import PrintQueueMonitor from "./settings/print-queue/PrintQueueMonitor";
import ZaloOtpSettings from "./settings/zalo/ZaloOtpSettings";
import FeeSettings from "./settings/fee/FeeSettings";
import CrawlerSettings from "./settings/crawler/CrawlerSettings";
import SepayCombined from "./settings/sepay/SepayCombined";
import HandoverDocs from "./settings/docs/HandoverDocs";
import PrivacyContactCombined from "./settings/privacy-contact/PrivacyContactCombined";
import PaymentCombined from "./settings/payment-combined/PaymentCombined";

// classic
import ClassicListReward from "./__classic__/list-reward/ListReward";
import ClassicChannel from "./__classic__/channel/Channel";
import ClassicResult from "./__classic__/result/Result";
import ClassicReward from "./__classic__/reward/Reward";
import ClassicRewardCombined from "./__classic__/reward-combined/RewardCombined";
import ClassicNewCart from "./__classic__/new-cart/Cart";
import ClassicDoneCart from "./__classic__/done-cart/Cart";
import ClassicTicket from "./__classic__/ticket/Ticket";
import ClassicTicketStorage from "./__classic__/ticket-storage/TicketStorage";
import ClassicTicketInput from "./__classic__/input/Input";
import ClassicTicketInputWithTabs from "./__classic__/input/InputWithTabs";
import ClassicPeriodWithTabs from "./__classic__/period/PeriodWithTabs";
import ClassicChannelWithTabs from "./__classic__/channel/ChannelWithTabs";
import ClassicTicketSales from "./__classic__/sales-ticket-storage/SalesTicketStorage";
import ClassicStatistic from "./__classic__/statistic/Statistic";
import ClassicStatisticByUnmarketableTicket from "./__classic__/statistic-by-unmarketable-ticket/Statistic";
import ClassicStatisticByTicket from "./__classic__/statistic-by-ticket/Statistic";
import ClassicSearch from "./__classic__/search/Search";
import ClassicPeriod from "./__classic__/period/Period";
import ClassicOrder from "./__classic__/order/Order";
import ClassicTicketReturn from "./__classic__/ticket-return/TicketReturn";
import ClassicUnmarketableTickets from "./__classic__/unmarketable-tickets/UnmarketableTickets";

import LotoPeriod from "./__loto__/period/Period";
import LotoReward from "./__loto__/reward/Reward";
import LotoCart from "./__loto__/cart/Cart";
import LotoStatisticByTicket from "./__loto__/statistic-by-ticket/Statistic";
import LotoSetting from "./__loto__/setting/Setting";
import LotoThudoPeriod from "./loto-thudo/Period";
import LotoThudoStatistic from "./loto-thudo/Statistic";

import { checkToken } from "../controller/api/auth";
import { messaging } from "../firebase";
import { getToken } from "firebase/messaging";
import { submitFbToken } from "../controller/api/messageToken";
import ClassicSidebar from "../components/ClassicSidebar";
import ChargeList from "./statistic/charge-list/ChargeList";
import Maintained from "./__vietlott__/maintained/Maintained";
import BankSummary from "./statistic/bank-summary/BankSummary";
import EwalletAndPaymentGatewaySummary from "./statistic/ewallet-and-payment-gateway-summary/EwalletAndPaymentGatewaySummary";
import EwalletAndPaymentGatewayDetail from "./statistic/ewallet-and-payment-gateway-detail/EwalletAndPaymentGatewayDetail";
import LotoSidebar from "../components/LotoSidebar";
import CustomerSidebar from "../components/CustomerSidebar";
import SettingSidebar from "../components/SettingSidebar";
import DeviceManagementSidebar from "../components/DeviceManagementSidebar";

import {
  countEnabledPermissions,
  normalizePermission,
} from "../helper/permission";

const resolveDefaultRoute = (permission = "") => {
  const normalized = normalizePermission(permission);
  const routePriority = [
    { index: 2, path: Routes.VietlottCart.path },
    { index: 3, path: Routes.ClassicOverview.path },
    { index: 4, path: Routes.LotoOverview.path },
    { index: 0, path: Routes.CustomerOverview.path },
    { index: 1, path: Routes.SettingOverview.path },
  ];

  for (const candidate of routePriority) {
    if (normalized[candidate.index] === "1") {
      return candidate.path;
    }
  }

  return Routes.Overview.path;
};

const hasMultiplePermissions = (permission = "") => {
  return countEnabledPermissions(permission) > 1;
};

const RouteWithLoader = ({ component: Component, ...rest }) => {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setLoaded(true), 1000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <Route
      {...rest}
      render={(props) => (
        <>
          {" "}
          <Preloader show={loaded ? false : true} />{" "}
          <Component {...props} />{" "}
        </>
      )}
    />
  );
};

const RouteWithSidebar = ({ component: Component, ...rest }) => {
  const itemPerPage = useItemPerPage();

  const localStorageIsSettingsVisible = () => {
    return localStorage.getItem("settingsVisible") === "false" ? false : true;
  };

  const [showSettings, setShowSettings] = useState(
    localStorageIsSettingsVisible,
  );

  const toggleSettings = () => {
    setShowSettings(!showSettings);
    localStorage.setItem("settingsVisible", !showSettings);
  };

  return (
    <Route
      {...rest}
      render={(props) => (
        <>
          <Sidebar />

          <main className="content">
            <Navbar />
            <SystemNotificationBanner />
            <Component key={itemPerPage} {...props} />
            <Footer
              toggleSettings={toggleSettings}
              showSettings={showSettings}
            />
          </main>
        </>
      )}
    />
  );
};

const RouteWithClassicSidebar = ({ component: Component, ...rest }) => {
  const itemPerPage = useItemPerPage();

  const localStorageIsSettingsVisible = () => {
    return localStorage.getItem("settingsVisible") === "false" ? false : true;
  };

  const [showSettings, setShowSettings] = useState(
    localStorageIsSettingsVisible,
  );

  const toggleSettings = () => {
    setShowSettings(!showSettings);
    localStorage.setItem("settingsVisible", !showSettings);
  };

  return (
    <Route
      {...rest}
      render={(props) => (
        <>
          <ClassicSidebar />

          <main className="content">
            <Navbar />
            <SystemNotificationBanner />
            <Component key={itemPerPage} {...props} region={rest.region || ""} />
            <Footer
              toggleSettings={toggleSettings}
              showSettings={showSettings}
            />
          </main>
        </>
      )}
    />
  );
};

const RouteWithLotoSidebar = ({ component: Component, ...rest }) => {
  const itemPerPage = useItemPerPage();

  const localStorageIsSettingsVisible = () => {
    return localStorage.getItem("settingsVisible") === "false" ? false : true;
  };

  const [showSettings, setShowSettings] = useState(
    localStorageIsSettingsVisible,
  );

  const toggleSettings = () => {
    setShowSettings(!showSettings);
    localStorage.setItem("settingsVisible", !showSettings);
  };

  return (
    <Route
      {...rest}
      render={(props) => (
        <>
          <LotoSidebar />

          <main className="content">
            <Navbar />
            <SystemNotificationBanner />
            <Component key={itemPerPage} {...props} region={rest.region || ""} />
            <Footer
              toggleSettings={toggleSettings}
              showSettings={showSettings}
            />
          </main>
        </>
      )}
    />
  );
};

const RouteWithCustomerSidebar = ({ component: Component, ...rest }) => {
  const itemPerPage = useItemPerPage();

  const localStorageIsSettingsVisible = () => {
    return localStorage.getItem("settingsVisible") === "false" ? false : true;
  };

  const [showSettings, setShowSettings] = useState(
    localStorageIsSettingsVisible,
  );

  const toggleSettings = () => {
    setShowSettings(!showSettings);
    localStorage.setItem("settingsVisible", !showSettings);
  };

  return (
    <Route
      {...rest}
      render={(props) => (
        <>
          <CustomerSidebar />

          <main className="content">
            <Navbar />
            <SystemNotificationBanner />
            <Component key={itemPerPage} {...props} region={rest.region || ""} />
            <Footer
              toggleSettings={toggleSettings}
              showSettings={showSettings}
            />
          </main>
        </>
      )}
    />
  );
};

const RouteWithSettingSidebar = ({ component: Component, ...rest }) => {
  const itemPerPage = useItemPerPage();

  const localStorageIsSettingsVisible = () => {
    return localStorage.getItem("settingsVisible") === "false" ? false : true;
  };

  const [showSettings, setShowSettings] = useState(
    localStorageIsSettingsVisible,
  );

  const toggleSettings = () => {
    setShowSettings(!showSettings);
    localStorage.setItem("settingsVisible", !showSettings);
  };

  return (
    <Route
      {...rest}
      render={(props) => (
        <>
          <SettingSidebar />

          <main className="content">
            <Navbar />
            <SystemNotificationBanner />
            <Component key={itemPerPage} {...props} region={rest.region || ""} />
            <Footer
              toggleSettings={toggleSettings}
              showSettings={showSettings}
            />
          </main>
        </>
      )}
    />
  );
};

const RouteWithDeviceManagementSidebar = ({
  component: Component,
  ...rest
}) => {
  const itemPerPage = useItemPerPage();

  const localStorageIsSettingsVisible = () => {
    return localStorage.getItem("settingsVisible") === "false" ? false : true;
  };

  const [isSettingsVisible, setIsSettingsVisible] = useState(
    localStorageIsSettingsVisible,
  );

  const toggleSettings = () => {
    setIsSettingsVisible(!isSettingsVisible);
    localStorage.setItem("settingsVisible", !isSettingsVisible);
  };

  return (
    <Route
      {...rest}
      render={(props) => (
        <>
          <DeviceManagementSidebar />

          <main className="content">
            <Navbar />
            <SystemNotificationBanner />
            <Component key={itemPerPage} {...props} />
            <Footer
              toggleSettings={toggleSettings}
              isSettingsVisible={isSettingsVisible}
            />
          </main>
        </>
      )}
    />
  );
};

export default () => {
  const [cookies] = useCookies(["lottmekong"]);

  const history = useHistory();

  const checkTokenFunc = useCallback(async () => {
    if (!cookies.lottmekong) {
      history.replace(Routes.Signin.path);
    } else {
      const response = await checkToken(cookies.lottmekong);

      if (response && response.status === "success") {
        const permission =
          response.permission || localStorage.getItem("permission") || "";
        const normalizedPermission = normalizePermission(permission);
        if (normalizedPermission) {
          localStorage.setItem("permission", normalizedPermission);
        }

        const defaultRoute = resolveDefaultRoute(normalizedPermission);
        const allowHubSelection = hasMultiplePermissions(normalizedPermission);

        if (history.location.pathname.includes(Routes.Signin.path)) {
          history.replace(
            allowHubSelection ? Routes.Overview.path : defaultRoute,
          );
        } else if (
          !allowHubSelection &&
          history.location.pathname === Routes.Overview.path &&
          defaultRoute !== Routes.Overview.path
        ) {
          history.replace(defaultRoute);
        }
      } else {
        history.replace(Routes.Signin.path);
      }
    }
  }, [cookies.lottmekong, history]);

  useEffect(() => {
    checkTokenFunc();
  }, [checkTokenFunc]);

  useEffect(() => {
    getToken(messaging, {
      vapidKey:
        "BOOzpS8OU5F3A9l6nTBZXIrrbjLxBKYHauMzejqh2HXjMPQIChneTSW7r9KW8rgpbNyFNBItfa5xKr0_kcCBs-M",
    })
      .then((currentToken) => {
        submitFbToken(cookies.lottmekong, currentToken);
      })
      .catch(() => {
        // alert(1)
      });
  }, [cookies.lottmekong]);

  return (
    <Switch>
      {/* authen */}
      <RouteWithLoader exact path={Routes.Signin.path} component={Signin} />
      <RouteWithLoader exact path={Routes.Signup.path} component={Signup} />
      <RouteWithLoader
        exact
        path={Routes.ForgotPassword.path}
        component={ForgotPassword}
      />
      <RouteWithLoader
        exact
        path={Routes.ResetPassword.path}
        component={ResetPassword}
      />
      <RouteWithLoader
        exact
        path={Routes.ServerError.path}
        component={ServerError}
      />

      {/* trang chủ */}
      <Route exact path={Routes.Overview.path} component={Overview} />
      <Route path={Routes.NotificationManagement.path} component={NotificationManagement} />
      <RouteWithCustomerSidebar
        exact
        path={Routes.CustomerOverview.path}
        component={CustomerOverview}
      />
      <RouteWithSettingSidebar
        exact
        path={Routes.SettingOverview.path}
        component={SettingOverview}
      />
      <RouteWithDeviceManagementSidebar
        exact
        path={Routes.DeviceManagementOverview.path}
        component={DeviceManagementOverview}
      />
      <RouteWithDeviceManagementSidebar
        exact
        path={Routes.DeviceManagementDevices.path}
        component={DeviceManagementDevices}
      />
      <RouteWithDeviceManagementSidebar
        exact
        path={Routes.DeviceManagementEmployees.path}
        component={DeviceManagementEmployees}
      />
      <RouteWithDeviceManagementSidebar
        exact
        path={Routes.DeviceManagementAdmins.path}
        component={DeviceManagementAdmins}
      />
      <RouteWithDeviceManagementSidebar
        exact
        path={Routes.DeviceManagementPrintQueue.path}
        component={DeviceManagementPrintQueue}
      />
      <Route
        exact
        path={Routes.VietlottOverview.path}
        render={() => <Redirect to={Routes.VietlottCart.path} />}
      />
      <RouteWithClassicSidebar
        exact
        path={Routes.ClassicOverview.path}
        component={ClassicOverview}
      />
      <Route
        exact
        path={Routes.LotoOverview.path}
        render={() => <Redirect to={Routes.LotoCart.path} />}
      />
      <Route
        exact
        path={Routes.LotoThudoOverview.path}
        render={() => <Redirect to={Routes.LotoThudoPeriod.path} />}
      />

      {/* CUSTOMER */}
      <RouteWithCustomerSidebar
        exact
        path={Routes.CustomerAddChargeApp.path}
        component={AddChargeApp}
      />
      <RouteWithCustomerSidebar
        exact
        path={Routes.CustomerAddChargeWeb.path}
        component={AddChargeWeb}
      />
      <RouteWithCustomerSidebar
        exact
        path={Routes.CustomerChargeHistoryWeb.path}
        component={ChargeHistoryWeb}
      />
      <RouteWithCustomerSidebar
        exact
        path={Routes.CustomerCashbackHistoryWeb.path}
        component={CashbackHistoryWeb}
      />
      <RouteWithCustomerSidebar
        exact
        path={Routes.CustomerChargeHistoryApp.path}
        component={ChargeHistoryApp}
      />
      <RouteWithCustomerSidebar
        exact
        path={Routes.CustomerIssueCharge.path}
        component={IssueCharge}
      />
      <RouteWithCustomerSidebar
        exact
        path={Routes.CustomerRefundApp.path}
        component={RefundApp}
      />
      <RouteWithCustomerSidebar
        exact
        path={Routes.CustomerRefundWeb.path}
        component={RefundWeb}
      />
      <RouteWithCustomerSidebar
        exact
        path={Routes.CustomerRefundHistoryWeb.path}
        component={RefundHistoryWeb}
      />
      <RouteWithCustomerSidebar
        exact
        path={Routes.CustomerRefundHistoryApp.path}
        component={RefundHistoryApp}
      />
      <RouteWithCustomerSidebar
        exact
        path={Routes.CustomerWithdrawRequestWebConfirmed.path}
        component={WithdrawRequestWebConfirmed}
      />
      <RouteWithCustomerSidebar
        exact
        path={Routes.CustomerWithdrawRequestAppConfirmed.path}
        component={WithdrawRequestAppConfirmed}
      />
      <RouteWithCustomerSidebar
        exact
        path={Routes.CustomerWithdrawRequestWeb.path}
        component={WithdrawRequestWeb}
      />
      <RouteWithCustomerSidebar
        exact
        path={Routes.CustomerWithdrawRequestApp.path}
        component={WithdrawRequestApp}
      />
      <RouteWithCustomerSidebar
        exact
        path={Routes.CustomerUser.path}
        component={User}
      />
      <RouteWithCustomerSidebar
        exact
        path={Routes.CustomerTransactionHistory.path}
        component={TransactionHistory}
      />
      <RouteWithCustomerSidebar
        exact
        path={Routes.CustomerCashFlow.path}
        component={CashFlow}
      />
      <RouteWithCustomerSidebar
        exact
        path={Routes.CustomerChargeSummary.path}
        component={ChargeSummary}
      />
      <Route
        exact
        path={Routes.CustomerNewUserSummary.path}
        render={() => <Redirect to={Routes.CustomerUser.path} />}
      />
      <RouteWithCustomerSidebar
        exact
        path={Routes.CustomerWithdrawSummaryApp.path}
        component={WithdrawSummaryApp}
      />
      <RouteWithCustomerSidebar
        exact
        path={Routes.CustomerWithdrawSummaryWeb.path}
        component={WithdrawSummaryWeb}
      />

      <RouteWithCustomerSidebar
        exact
        path={Routes.MBRefund.path}
        component={MBRefund}
      />
      <RouteWithCustomerSidebar
        exact
        path={Routes.MBDoisoat.path}
        component={MBDoisoat}
      />

      {/* VIETLOTT */}
      <RouteWithSidebar
        exact
        path={Routes.VietlottCart.path}
        component={Cart}
      />
      <RouteWithSidebar
        exact
        path={Routes.VietlottTicket.path}
        component={Ticket}
      />
      <RouteWithSidebar
        exact
        path={Routes.VietlottKenoResult.path}
        component={KenoResult}
      />
      <RouteWithSidebar
        exact
        path={Routes.VietlottPowerResult.path}
        component={PowerResult}
      />
      <RouteWithSidebar
        exact
        path={Routes.VietlottMegaResult.path}
        component={MegaResult}
      />
      <RouteWithSidebar
        exact
        path={Routes.VietlottLotto535Result.path}
        component={Lotto535Result}
      />
      <RouteWithSidebar
        exact
        path={Routes.VietlottMax3dResult.path}
        component={Max3dResult}
      />
      <RouteWithSidebar
        exact
        path={Routes.VietlottMax3dProResult.path}
        component={Max3dProResult}
      />
      <RouteWithSidebar
        exact
        path={Routes.VietlottRewardCalcJob.path}
        component={RewardCalcJob}
      />
      <RouteWithSidebar
        exact
        path={Routes.VietlottRewardCalcSetting.path}
        component={RewardCalcSetting}
      />
      <RouteWithSidebar
        exact
        path={Routes.VietlottCurrentPeriod.path}
        component={CurrentPeriod}
      />
      <RouteWithSidebar
        exact
        path={Routes.VietlottDayOff.path}
        component={DayOff}
      />
      <RouteWithSidebar
        exact
        path={Routes.VietlottKenoPeriod.path}
        component={KenoPeriod}
      />
      <RouteWithSidebar
        exact
        path={Routes.VietlottPowerPeriod.path}
        component={PowerPeriod}
      />
      <RouteWithSidebar
        exact
        path={Routes.VietlottMegaPeriod.path}
        component={MegaPeriod}
      />
      <RouteWithSidebar
        exact
        path={Routes.VietlottLotto535Period.path}
        component={Lotto535Period}
      />
      <RouteWithSidebar
        exact
        path={Routes.VietlottMax3dPeriod.path}
        component={Max3dPeriod}
      />
      <RouteWithSidebar
        exact
        path={Routes.VietlottMax3dProPeriod.path}
        component={Max3dProPeriod}
      />
      <RouteWithSidebar
        exact
        path={Routes.VietlottReward.path}
        component={Reward}
      />
      <Route
        exact
        path={Routes.VietlottBigReward.path}
        render={() => <Redirect to={Routes.VietlottReward.path} />}
      />
      <Route
        exact
        path="/vietlott/reward/reward"
        render={() => <Redirect to={Routes.VietlottReward.path} />}
      />

      {/* CLASSIC */}
      <RouteWithClassicSidebar
        exact
        path={Routes.ClassicTicketInput.path}
        component={ClassicTicketInputWithTabs}
      />
      <RouteWithClassicSidebar
        exact
        path={Routes.ClassicPeriodCombined.path}
        component={ClassicPeriodWithTabs}
      />
      <RouteWithClassicSidebar
        exact
        path={Routes.ClassicChannelCombined.path}
        component={ClassicChannelWithTabs}
      />
      <RouteWithClassicSidebar
        exact
        path={Routes.ClassicRewardCalcSetting.path}
        component={RewardCalcSetting}
      />
      <RouteWithClassicSidebar
        exact
        path={Routes.ClassicMNTicketInput.path}
        component={ClassicTicketInput}
        region={"MN"}
      />
      <RouteWithClassicSidebar
        exact
        path={Routes.ClassicMTTicketInput.path}
        component={ClassicTicketInput}
        region={"MT"}
      />
      <RouteWithClassicSidebar
        exact
        path={Routes.ClassicListReward.path}
        component={ClassicListReward}
      />
      <RouteWithClassicSidebar
        exact
        path={Routes.ClassicMNChannel.path}
        component={ClassicChannel}
        region={"MN"}
      />
      <RouteWithClassicSidebar
        exact
        path={Routes.ClassicMTChannel.path}
        component={ClassicChannel}
        region={"MT"}
      />
      <RouteWithClassicSidebar
        exact
        path={Routes.ClassicMBChannel.path}
        component={ClassicChannel}
        region={"MB"}
      />
      <RouteWithClassicSidebar
        exact
        path={Routes.ClassicTicketSalesCombined.path}
        component={ClassicTicketSales}
      />
      <RouteWithClassicSidebar
        exact
        path={Routes.ClassicMNTicketSales.path}
        component={ClassicTicketSales}
        region={"MN"}
      />
      <RouteWithClassicSidebar
        exact
        path={Routes.ClassicMTTicketSales.path}
        component={ClassicTicketSales}
        region={"MT"}
      />
      <RouteWithClassicSidebar
        exact
        path={Routes.ClassicMBTicketSales.path}
        component={ClassicTicketSales}
        region={"MB"}
      />
      <RouteWithClassicSidebar
        exact
        path={Routes.ClassicResult.path}
        component={ClassicResult}
      />
      <RouteWithClassicSidebar
        exact
        path={Routes.ClassicMNReward.path}
        component={ClassicReward}
        region={"MN"}
      />
      <RouteWithClassicSidebar
        exact
        path={Routes.ClassicMTReward.path}
        component={ClassicReward}
        region={"MT"}
      />
      <RouteWithClassicSidebar
        exact
        path={Routes.ClassicMBReward.path}
        component={ClassicReward}
        region={"MB"}
      />
      <RouteWithClassicSidebar
        exact
        path={Routes.ClassicTicket.path}
        component={ClassicTicket}
      />
      <RouteWithClassicSidebar
        exact
        path={Routes.ClassicTicketStorage.path}
        component={ClassicTicketStorage}
      />
      <RouteWithClassicSidebar
        exact
        path={Routes.ClassicStatistic.path}
        component={ClassicStatistic}
      />
      <RouteWithClassicSidebar
        exact
        path={Routes.ClassicStatisticByTicket.path}
        component={ClassicStatisticByTicket}
      />
      <RouteWithClassicSidebar
        exact
        path={Routes.ClassicStatisticByUnmarketableTicket.path}
        component={ClassicStatisticByUnmarketableTicket}
      />
      <RouteWithClassicSidebar
        exact
        path={Routes.ClassicMNPeriod.path}
        component={ClassicPeriod}
        region={"MN"}
      />
      <RouteWithClassicSidebar
        exact
        path={Routes.ClassicMTPeriod.path}
        component={ClassicPeriod}
        region={"MT"}
      />
      <RouteWithClassicSidebar
        exact
        path={Routes.ClassicMBPeriod.path}
        component={ClassicPeriod}
        region={"MB"}
      />
      <RouteWithClassicSidebar
        exact
        path={Routes.ClassicMNNewCart.path}
        component={ClassicNewCart}
        region={"MN"}
      />
      <RouteWithClassicSidebar
        exact
        path={Routes.ClassicMTNewCart.path}
        component={ClassicNewCart}
        region={"MT"}
      />
      <RouteWithClassicSidebar
        exact
        path={Routes.ClassicMBNewCart.path}
        component={ClassicNewCart}
        region={"MB"}
      />
      <RouteWithClassicSidebar
        exact
        path={Routes.ClassicMNDoneCart.path}
        component={ClassicDoneCart}
        region={"MN"}
      />
      <RouteWithClassicSidebar
        exact
        path={Routes.ClassicMTDoneCart.path}
        component={ClassicDoneCart}
        region={"MT"}
      />
      <RouteWithClassicSidebar
        exact
        path={Routes.ClassicMBDoneCart.path}
        component={ClassicDoneCart}
        region={"MB"}
      />
      <RouteWithClassicSidebar
        exact
        path={Routes.ClassicOrder.path}
        component={ClassicOrder}
      />
      <RouteWithClassicSidebar
        exact
        path={Routes.ClassicReward.path}
        component={ClassicRewardCombined}
      />
      <RouteWithClassicSidebar
        exact
        path={Routes.ClassicSearch.path}
        component={ClassicSearch}
      />
      <RouteWithClassicSidebar
        exact
        path={Routes.ClassicTicketReturn.path}
        component={ClassicTicketReturn}
      />
      <RouteWithClassicSidebar
        exact
        path={Routes.ClassicUnmarketableTickets.path}
        component={ClassicUnmarketableTickets}
      />

      {/* LOTO */}
      <RouteWithLotoSidebar
        exact
        path={Routes.LotoPeriod.path}
        component={LotoPeriod}
      />
      <RouteWithLotoSidebar
        exact
        path={Routes.LotoCart.path}
        component={LotoCart}
      />
      <RouteWithLotoSidebar
        exact
        path={Routes.LotoReward.path}
        component={LotoReward}
      />
      <RouteWithLotoSidebar
        exact
        path={Routes.LotoStatisticByTicket.path}
        component={LotoStatisticByTicket}
      />
      <RouteWithLotoSidebar
        exact
        path={Routes.LotoSetting.path}
        component={LotoSetting}
      />
      <RouteWithLotoSidebar
        exact
        path={Routes.LotoRewardCalcSetting.path}
        component={RewardCalcSetting}
      />
      <RouteWithLotoSidebar
        exact
        path={Routes.LotoThudoPeriod.path}
        component={LotoThudoPeriod}
      />
      <RouteWithLotoSidebar
        exact
        path={Routes.LotoThudoStatisticByTicket.path}
        component={LotoThudoStatistic}
      />

      {/* SETTING */}
      <RouteWithSettingSidebar
        exact
        path={Routes.SettingMaintained.path}
        component={Maintained}
      />
      {/* <RouteWithSettingSidebar exact path={Routes.SettingDevices.path} component={Devices} /> */}
      <RouteWithSettingSidebar
        exact
        path={Routes.SettingNotification.path}
        component={Notification}
      />
      <RouteWithSettingSidebar
        exact
        path={Routes.SettingZalo.path}
        component={ZaloOtpSettings}
      />
      <RouteWithSettingSidebar
        exact
        path={Routes.SettingGames.path}
        component={Games}
      />
      <RouteWithSettingSidebar
        exact
        path={Routes.SettingPaymentMethod.path}
        component={PaymentCombined}
      />
      <RouteWithSettingSidebar
        exact
        path={Routes.SettingAccount.path}
        component={PaymentCombined}
      />
      <RouteWithSettingSidebar
        exact
        path={Routes.SettingBank.path}
        component={Bank}
      />
      <RouteWithSettingSidebar
        exact
        path={Routes.SettingBanner.path}
        component={Banner}
      />
      <RouteWithSettingSidebar
        exact
        path={Routes.SettingPrivacy.path}
        component={PrivacyContactCombined}
      />
      <RouteWithSettingSidebar
        exact
        path={Routes.SettingContact.path}
        component={PrivacyContactCombined}
      />
      <RouteWithSettingSidebar
        exact
        path={Routes.SettingInvite.path}
        component={Invite}
      />
      {/* <RouteWithSettingSidebar exact path={Routes.SettingEmployee.path} component={Employee} /> */}
      <RouteWithSettingSidebar
        exact
        path={Routes.SettingSystemNotification.path}
        component={SystemNotification}
      />
      <RouteWithSettingSidebar
        exact
        path={Routes.SettingFee.path}
        component={FeeSettings}
      />
      <RouteWithSettingSidebar
        exact
        path={Routes.SettingCrawler.path}
        component={CrawlerSettings}
      />
      <RouteWithSettingSidebar
        exact
        path={Routes.SettingDepositWithdraw.path}
        component={PaymentCombined}
      />
      <RouteWithSettingSidebar
        exact
        path={Routes.SettingSePayTransactions.path}
        component={SepayCombined}
      />
      <RouteWithSettingSidebar
        exact
        path={Routes.SettingSePay.path}
        component={SepayCombined}
      />
      <Route
        exact
        path={Routes.SettingHandoverDocs.path}
        component={HandoverDocs}
      />

      <Redirect to={Routes.NotFound.path} />
    </Switch>
  );
};
